import React from "react";
import { Video } from "../OrcaPlayer.stitches";
import { useVideoDataContext } from "../contexts/VideoDataContext";
import { useVideoElementRefContext } from "../contexts/VideoElementRefContext";
import { addOrcaEvent } from "../utils";
import { OrcaWindowEvents } from "../../globals";
import { useOrcaCommonContext } from "../contexts/OrcaCommonContext";
import PropTypes from "prop-types";

export const OrcaVideo = ({
  updateCues,
  handleVideoEnd,
  isStickyEnabled,
  updateStickyContext,
  updateDisplay,
  debug
}) => {
  const { videoId, uniqueId } = useVideoDataContext();
  const videoElementRef = useVideoElementRefContext();
  const { handlePlayEvent } = useOrcaCommonContext();

  const handlePlay = () => {
    addOrcaEvent(OrcaWindowEvents.PLAY, true, videoId, debug);

    handlePlayEvent(true);
    if (isStickyEnabled) {
      updateStickyContext({ playingId: uniqueId });
      updateDisplay({ state: "media-start" });
    }
  };

  const handlePause = () => {
    addOrcaEvent(OrcaWindowEvents.PAUSE, true, videoId, debug);
    handlePlayEvent(false);
  };

  return (
    <Video
      id={`orca-video-${videoId}`}
      data-testid="orca-video"
      className="orca-video"
      aria-hidden="true"
      crossOrigin="anonymous"
      ref={videoElementRef}
      onTimeUpdate={updateCues}
      onEnded={handleVideoEnd}
      onPlay={handlePlay}
      onPause={handlePause}
      onVolumeChange={() => {
        addOrcaEvent(
          OrcaWindowEvents.VOLUME_CHANGE,
          videoElementRef.current.volume,
          videoId,
          debug
        );
      }}
      preload="metadata" // should we add logic to preload="none"?
      controlsList="nodownload"
      playsInline
    />
  );
};

OrcaVideo.propTypes = {
  updateCues: PropTypes.func.isRequired,
  handleVideoEnd: PropTypes.func.isRequired,
  isStickyEnabled: PropTypes.bool,
  updateStickyContext: PropTypes.func,
  updateDisplay: PropTypes.func,
  debug: PropTypes.bool
};
